module.exports = __webpack_public_path__ + "img/plan.f1a43ea5.png";